export type TalkingPointRemarkPayload = {
  selectedTagIds: number[] | undefined
  isClientMeetingRemark: boolean
}

export default function talkingPointRemarkPayload(
  presentationMode: boolean
): TalkingPointRemarkPayload {
  const tags = window.allRemarkTags || {}
  const talkingPointTag = presentationMode
    ? Object.values(tags).find((tag) => tag.talkingPoint)
    : undefined

  return {
    selectedTagIds: talkingPointTag ? [talkingPointTag.id] : undefined,
    isClientMeetingRemark: !!talkingPointTag,
  }
}
